import React from "react";

const Footer = () => {
  return (
    <div className="p-[25px] text-[13px] bg-white mt-5 text-[#000] text-center border-t border-[#eee]">
      <p>© copyright 2022 - All Right Reserved by Faucet</p>
    </div>
  );
};

export default Footer;
